module.exports = __webpack_public_path__ + "img/google.242b7b7e.png";